module.exports = __webpack_public_path__ + "img/documents_empty.5dfb8de4.svg";